/* =========================================================
   SUPPLEMENT PRODUCT PAGE  (template: product.supplement)
   Gallery · bundles + add to cart (opens Horizon's cart drawer) · countdown
   Ingredient carousel · testimonial swipe · sticky bar · video popup
   Cart count · [placeholder] highlight · theme editor support
   ========================================================= */
(function () {
  'use strict';

  var CART_EVENT = 'shopify:cart:lines-update';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var behavior = reduceMotion ? 'auto' : 'smooth';

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  function parseItems(json) {
    try { return JSON.parse(json).filter(function (i) { return i && i.id; }); } catch (e) { return []; }
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------------- Cart ---------------- */
  function addWithAjax(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: Number(i.id), quantity: i.quantity || 1 }; }) })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        window.location.href = root() + 'cart';
      });
    });
  }
  function openDrawer(actions) {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && drawer.isOpen) return;
    if (actions && typeof actions.openCart === 'function') return actions.openCart();
  }
  function addItems(items, button, errorEl, errorText) {
    if (!items.length) return;
    var actions = window.Shopify && window.Shopify.actions;
    if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('sp-show'); }
    if (button) { button.classList.add('sp-loading'); button.setAttribute('aria-busy', 'true'); }
    function fail(msg) { if (errorEl) { errorEl.textContent = msg || errorText; errorEl.classList.add('sp-show'); } }
    function done() { if (button) { button.classList.remove('sp-loading'); button.removeAttribute('aria-busy'); } }
    var job;
    if (actions && typeof actions.updateCart === 'function') {
      job = actions
        .updateCart({ lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity || 1 }; }) }, { event: { context: 'product' } })
        .then(function (res) {
          if (res && res.userErrors && res.userErrors.length) { fail(res.userErrors[0].message); return; }
          return openDrawer(actions);
        })
        .catch(function (err) {
          console.warn('[supplement] updateCart failed, using /cart/add.js', err);
          return addWithAjax(items).catch(function (e) { fail(e.message); });
        });
    } else {
      job = addWithAjax(items).catch(function (e) { fail(e.message); });
    }
    job.then(done, done);
  }
  // Section ids the theme renders the cart with (drawer + cart page).
  function cartSectionIds() {
    var ids = [];
    each(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  // Horizon's cart components listen for this event and read `event.promise`,
  // morphing from `detail.sections` when present and refetching when not.
  function announceCartUpdate(sections) {
    var event;
    try {
      event = new CustomEvent(CART_EVENT, { bubbles: true, cancelable: false });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(CART_EVENT, true, false, null);
    }
    event.action = 'add';
    event.source = 'supplement-template';
    event.promise = Promise.resolve({ detail: { sections: sections || {} } });
    document.dispatchEvent(event);
  }

  function submitForm(form, button, errorEl, errorText) {
    var actions = window.Shopify && window.Shopify.actions;
    if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('sp-show'); }
    function fail(msg) { if (errorEl) { errorEl.textContent = msg || errorText; errorEl.classList.add('sp-show'); } }
    function done() { if (button) { button.classList.remove('sp-loading'); button.removeAttribute('aria-busy'); } }

    var params = new URLSearchParams();
    var hasItems = false;
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (typeof value !== 'string') return;
      if (key.indexOf('items[') === 0) hasItems = true;
      params.append(key, value);
    });
    // A multi-line payload and a single id cannot be sent together.
    if (hasItems) { params.delete('id'); params.delete('quantity'); }
    if (!hasItems && !params.get('id')) { fail(errorText); return; }

    // Ask for the cart sections in the same request so the drawer can morph
    // straight to the new contents instead of showing a stale (empty) cart.
    var sectionIds = cartSectionIds();
    if (sectionIds.length) {
      params.set('sections', sectionIds.join(','));
      params.set('sections_url', window.location.pathname);
    }

    if (button) { button.classList.add('sp-loading'); button.setAttribute('aria-busy', 'true'); }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: params.toString()
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || errorText);
          return d;
        });
      })
      .then(function (d) {
        announceCartUpdate(d && d.sections);
        refreshCartCount();
        return openDrawer(actions);
      })
      .catch(function (err) { fail(err && err.message); })
      .then(done, done);
  }

  function setCartCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    each(document.querySelectorAll('[data-sp-cart-count]'), function (el) { el.textContent = n; el.dataset.count = String(n); });
  }
  function refreshCartCount() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }
  document.addEventListener(CART_EVENT, function (event) {
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(function (res) {
        var q = res && res.cart && res.cart.totalQuantity;
        if (typeof q === 'number') setCartCount(q); else refreshCartCount();
      }).catch(function () {});
    } else {
      setTimeout(refreshCartCount, 400);
    }
  });
  function initCartButton(btn) {
    if (!once(btn, 'spReady')) return;
    btn.addEventListener('click', function (e) {
      var actions = window.Shopify && window.Shopify.actions;
      if (actions && typeof actions.openCart === 'function' && document.querySelector('theme-drawer#cart-drawer')) {
        e.preventDefault();
        actions.openCart();
      }
    });
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(gallery) {
    if (!once(gallery, 'spReady')) return;
    var track = gallery.querySelector('[data-sp-g-track]');
    if (!track || !track.children.length) return;
    var slides = track.children;
    var thumbs = gallery.querySelectorAll('[data-sp-thumb]');
    var prev = gallery.querySelector('[data-sp-g-prev]');
    var next = gallery.querySelector('[data-sp-g-next]');
    var index = 0;
    function mark(i) {
      index = i;
      each(thumbs, function (t) { t.classList.toggle('sp-is-active', Number(t.dataset.spThumb) === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      each(slides, function (s, j) {
        var v = s.querySelector('video');
        if (v && j !== i && !v.paused) v.pause();
      });
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: behavior });
      else track.scrollLeft = slides[i].offsetLeft - track.offsetLeft;
      mark(i);
    }
    gallery.spGo = go;
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    each(thumbs, function (t) { t.addEventListener('click', function () { go(Number(t.dataset.spThumb)); }); });
    var timer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var w = track.clientWidth || 1;
        mark(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
      }, 80);
    }, { passive: true });
    mark(0);
  }

  /* ---------------- Bundles + add to cart ---------------- */
  function initForm(form) {
    if (!once(form, 'spReady')) return;
    var bundles = form.querySelectorAll('[data-sp-bundle]');
    var idInput = form.querySelector('input[name="id"]');
    var button = form.querySelector('[data-sp-submit]');
    var label = form.querySelector('[data-sp-cta-label]');
    var errorEl = form.querySelector('[data-sp-error]');
    var soldOut = form.dataset.soldOutText || 'Sold out';
    var errorText = form.dataset.errorText || 'Something went wrong. Please try again.';
    var defaultLabel = label ? label.textContent : '';
    var selected = null;

    function select(bundle) {
      if (!bundle) return;
      selected = bundle;
      each(bundles, function (b) {
        var on = b === bundle;
        b.classList.toggle('sp-is-selected', on);
        var radio = b.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });
      var available = bundle.dataset.available === 'true';
      var items = parseItems(bundle.dataset.items);
      if (idInput && items[0]) idInput.value = items[0].id;
      if (label) label.textContent = available ? defaultLabel : soldOut;
      if (button) button.disabled = !available;
      if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('sp-show'); }
      each(document.querySelectorAll('[data-sp-sticky-label]'), function (el) { if (bundle.dataset.label) el.textContent = bundle.dataset.label; });
      each(document.querySelectorAll('[data-sp-sticky-price]'), function (el) { if (bundle.dataset.price) el.textContent = bundle.dataset.price; });
    }
    form.spSelect = select;

    each(bundles, function (bundle) {
      var radio = bundle.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', function () { select(bundle); });
    });
    select(form.querySelector('[data-sp-bundle].sp-is-selected') || bundles[0]);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = selected ? parseItems(selected.dataset.items) : [];
      if (items.length) { addItems(items, button, errorEl, errorText); return; }
      // No built-in bundle selected: post whatever the form actually holds, so
      // bundle apps (Kaching etc.), variant pickers, selling plans and line-item
      // properties all go through untouched.
      submitForm(form, button, errorEl, errorText);
    });
  }

  /* ---------------- "Add +" buttons (cross-sell) ---------------- */
  function initAddButton(btn) {
    if (!once(btn, 'spReady')) return;
    btn.addEventListener('click', function () { addItems(parseItems(btn.dataset.spAddItems), btn, null, 'Could not add to cart'); });
  }

  /* ---------------- Countdown ---------------- */
  function initCountdown(box) {
    if (!once(box, 'spReady')) return;
    var minutes = parseInt(box.dataset.minutes || '45', 10) || 45;
    var key = 'sp-countdown-end';
    var end = 0;
    try { end = parseInt(window.sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
    var now = Date.now();
    if (!end || end < now) {
      end = now + minutes * 60000;
      try { window.sessionStorage.setItem(key, String(end)); } catch (e) {}
    }
    var h = box.querySelector('[data-sp-cd-h]');
    var m = box.querySelector('[data-sp-cd-m]');
    var sEl = box.querySelector('[data-sp-cd-s]');
    var mirrors = document.querySelectorAll('[data-sp-cd-mirror]');
    var mirrorPrefix = mirrors.length ? (mirrors[0].textContent.split('[')[0] || '') : '';
    function tick() {
      var left = Math.max(0, end - Date.now());
      var total = Math.floor(left / 1000);
      var hh = Math.floor(total / 3600);
      var mm = Math.floor((total % 3600) / 60);
      var ss = total % 60;
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (sEl) sEl.textContent = pad(ss);
      each(mirrors, function (el) { el.textContent = mirrorPrefix + pad(hh) + ':' + pad(mm) + ':' + pad(ss); });
      if (left > 0) window.setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------------- Ingredient carousel ---------------- */
  function initCarousel(box) {
    if (!once(box, 'spReady')) return;
    var track = box.querySelector('[data-sp-track]');
    var counter = box.querySelector('[data-sp-counter]');
    var prev = box.querySelector('[data-sp-prev]');
    var next = box.querySelector('[data-sp-next]');
    if (!track || !track.children.length) return;
    var cards = track.children;
    var index = 0;
    function update() {
      if (counter) counter.textContent = (index + 1) + ' of ' + cards.length;
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === cards.length - 1;
    }
    function go(i) {
      index = Math.max(0, Math.min(cards.length - 1, i));
      if (typeof track.scrollTo === 'function') track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: behavior });
      update();
    }
    box.spGo = go;
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var best = 0;
        var dist = Infinity;
        each(cards, function (c, j) {
          var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < dist) { dist = d; best = j; }
        });
        index = best;
        update();
      }, 80);
    }, { passive: true });
    update();
  }

  /* ---------------- Testimonial swipe ---------------- */
  /* ---------------- Scroll indicator ----------------
     A thin bar that mirrors how far along a horizontal
     scroller you are. Sits directly after the scroller. */
  function initScrollbar(bar) {
    if (!once(bar, 'spReady')) return;
    var track = bar.previousElementSibling;
    var thumb = bar.firstElementChild;
    if (!track || !thumb) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) { bar.setAttribute('hidden', 'hidden'); return; }
      bar.removeAttribute('hidden');
      var visible = (track.clientWidth / track.scrollWidth) * 100;
      var progress = track.scrollLeft / max;
      thumb.style.width = visible + '%';
      thumb.style.marginLeft = progress * (100 - visible) + '%';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }

  function initSwipe(sec) {
    if (!once(sec, 'spReady')) return;
    var track = sec.querySelector('[data-sp-swipe-track]');
    if (!track) return;
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: behavior }); }
    var prev = sec.querySelector('[data-sp-swipe-prev]');
    var next = sec.querySelector('[data-sp-swipe-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ---------------- Sticky bar ---------------- */
  function initSticky(product) {
    if (!once(product, 'spSticky')) return;
    var sticky = product.querySelector('[data-sp-sticky]');
    var form = product.querySelector('[data-sp-form]');
    var button = product.querySelector('[data-sp-submit]');
    if (sticky) {
      var add = sticky.querySelector('[data-sp-sticky-add]');
      if (add && form) {
        add.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }
    // Follow the buy button, or the form itself when the built-in button is hidden.
    var anchor = button || form;
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('sp-show', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }
  }

  /* ---------------- Video popup ---------------- */
  function initVideo(btn) {
    if (!once(btn, 'spReady')) return;
    btn.addEventListener('click', function () {
      var src = btn.querySelector('.sp-video-src');
      var dialog = document.querySelector('[data-sp-lightbox]');
      if (!src || !dialog || !src.innerHTML.trim()) return;
      var stage = dialog.querySelector('[data-sp-lightbox-stage]');
      stage.innerHTML = src.innerHTML;
      var video = stage.querySelector('video');
      if (video) { video.setAttribute('controls', 'controls'); video.play().catch(function () {}); }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', 'open');
    });
  }
  function initLightbox(dialog) {
    if (!once(dialog, 'spReady')) return;
    var stage = dialog.querySelector('[data-sp-lightbox-stage]');
    function close() {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      if (stage) stage.innerHTML = '';
    }
    var closeBtn = dialog.querySelector('[data-sp-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { if (stage) stage.innerHTML = ''; });
  }

  /* ---------------- [placeholder] highlight ---------------- */
  var TODO_RE = /\[[^\]\n]{1,160}\]/g;
  function highlight(scope) {
    if (!document.body.classList.contains('lm-show-todo')) return;
    var boxes = scope.classList && scope.classList.contains('sp') ? [scope] : scope.querySelectorAll('.sp');
    each(boxes, function (box) {
      var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var p = node.parentNode;
          if (!p || /^(SCRIPT|STYLE|TEXTAREA|MARK)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
          TODO_RE.lastIndex = 0;
          return TODO_RE.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var text = node.nodeValue;
        var frag = document.createDocumentFragment();
        var last = 0;
        var m;
        TODO_RE.lastIndex = 0;
        while ((m = TODO_RE.exec(text))) {
          if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
          var mark = document.createElement('mark');
          mark.className = 'sp-todo';
          mark.textContent = m[0];
          frag.appendChild(mark);
          last = m.index + m[0].length;
        }
        if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
        node.parentNode.replaceChild(frag, node);
      });
    });
  }

  /* ---------------- Boot ---------------- */
  function init(scope) {
    scope = scope || document;
    each(scope.querySelectorAll('[data-sp-gallery]'), initGallery);
    each(scope.querySelectorAll('[data-sp-form]'), initForm);
    each(scope.querySelectorAll('[data-sp-add-items]'), initAddButton);
    each(scope.querySelectorAll('[data-sp-countdown]'), initCountdown);
    each(scope.querySelectorAll('[data-sp-carousel]'), initCarousel);
    each(scope.querySelectorAll('[data-sp-swipe]'), initSwipe);
    each(scope.querySelectorAll('[data-sp-scrollbar]'), initScrollbar);
    each(scope.querySelectorAll('.sp-product'), initSticky);
    each(scope.querySelectorAll('[data-sp-video]'), initVideo);
    each(scope.querySelectorAll('[data-sp-lightbox]'), initLightbox);
    each(scope.querySelectorAll('[data-sp-open-cart]'), initCartButton);
    highlight(scope === document ? document.body : scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    if (!block || !block.closest) return;
    var bundle = block.closest('[data-sp-bundle]');
    if (bundle) {
      var form = bundle.closest('[data-sp-form]');
      if (form && form.spSelect) form.spSelect(bundle);
    }
    var slide = block.closest('.sp-carousel-slide');
    if (slide) {
      var box = slide.closest('[data-sp-carousel]');
      if (box && box.spGo) box.spGo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
    }
  });
})();
